import { Link, useNavigate, useNavigation } from "react-router-dom";
import classes from "../components/loggedout/LoggedOut.module.scss";
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { DDD } from "../lib/ddd/ddd";
import { useContext, useState } from "react";
import axios from "axios";
import { OrgIdContext } from "../store/orgId_context";
import Button from "../components/UI/Button";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const apiRequestAddressBase = process.env.REACT_APP_ORIGIN || window.location.origin;

const ConfirmEmail = () => {
    const { t } = useTranslation();
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const goToLogin = () =>{
        navigate('/login', { state: { confirmemail:true} });
    }
    
    return (
        <div className={classes.card}>
            <div className={classes["card-content"]}>
                <div style={{marginBottom:"1rem"}}>{t("Please login to confirm your email")}</div>
                {/* <span ><Link to="/login?confirmemail=" className={classes["main-blue-link"]} style={{color: "rgb(0, 128, 0)"}}>{t("Login")}</Link></span> */}
                <Button className="ps-2 pe-2 mt-3" onClick={goToLogin}>{("Go to Login")}</Button>
                {/* <p className="mt-3 mb-0">{t("Do not have an account yet?")} <Link className={classes["special-orange-link"]} onClick={() => {window.location.href="@dashboard-sign-up";window.location.reload();}}>{t("Sign up")}</Link></p> */}
            </div>
        </div>
    );
}
export default ConfirmEmail;